<div *ngIf="busy">Two racquets started dating... Unfortunately, one was stringing the other along.<br />Loading....</div>
<div *ngIf="queryFailed">No tournament found. You may need to click '<a id="mylevels" class="" [routerLink]="['/ladderlevel']">My Ladders/Levels</a>' and switch to a different ladder?</div>

<div *ngIf="!busy && !queryFailed" class="tournament-bracket">

  <button *ngIf="showRecord" [routerLink]="['/record-tournament']" [queryParams]="{returnTo: '/tournament16'}">Record Match</button>
  &nbsp;
  <a [routerLink]="['/alltournament']">See All Brackets</a>



  <table style="background: #fff; width: 100%;">
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:0}}</td>
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:0}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:1}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:0}}</td>
      <td class="round4 left-bordered"></td>
      <td class="round2 "></td>
      <td class="round1"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:2}}</td>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:0}}</td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:1}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:0}}</td>
      <td class="round2 left-bordered"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:3}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:1}}</td>
      <td class="round4"></td>
      <td class="round2 player left-bordered">{{tournamentBracket.round2|player:0}} (2nd place)</td>
      <td class="round1"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:4}}</td>
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2 score left-bordered">{{tournamentBracket.round2|score:0}}</td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:2}}</td>
      <td class="round4"></td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:5}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:2}}</td>
      <td class="round4 left-bordered"></td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:6}}</td>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:1}} (3rd place)</td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:3}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:1}}</td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:7}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:3}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>

    
    <tr class="center-row">
      <td class="round16"></td>
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 player left-bordered">
        <fa-icon [icon]="faTrophy"></fa-icon>
        &nbsp;
        <b>{{tournamentBracket.round1|player:0}}</b>
      </td>
    </tr>

    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:8}}</td>
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 score left-bordered">{{tournamentBracket.round1|score:0}}</td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:4}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:9}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:4}}</td>
      <td class="round4 left-bordered"></td>
      <td class="round2 "></td>
      <td class="round1 left-bordered"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:10}}</td>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:2}} (4th place)</td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:5}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:2}}</td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:11}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:5}}</td>
      <td class="round4"></td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:12}}</td>
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2 player left-bordered">{{tournamentBracket.round2|player:1}}</td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:6}}</td>
      <td class="round4"></td>
      <td class="round2 score left-bordered">{{tournamentBracket.round2|score:1}}</td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:13}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:6}}</td>
      <td class="round4 left-bordered"></td>
      <td class="round2 left-bordered"></td>
      <td class="round1"></td>
    </tr>
    
    
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:14}}</td>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:3}}</td>
      <td class="round2 left-bordered"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16"></td>
      <td class="round8 player left-bordered">{{tournamentBracket.round8|player:7}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:3}}</td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round16 player">{{tournamentBracket.round16|player:15}}</td>
      <td class="round8 score left-bordered">{{tournamentBracket.round8|score:7}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
  </table>
<br /><br />









<div style="margin-left: 70px;">

<table class="losers-bracket-table" style="background: #fff; width: 100%;">
  <!-- Round 1 - Match 9 (L1 vs L2) -->
  <tr>
    <td class="round16 player">Dean W</td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player left-bordered"></td>
    <td class="round4"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  <tr>
    <td class="round16 player">Roman V</td>
    <td class="round8 score left-bordered"></td>
    <td class="round4 left-bordered"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  
  <!-- Round 2 - Match 17 (L16 vs winner of match 9) -->
  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4 player left-bordered placeholder">Winner 389</td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player ">Marcin D</td>
    <td class="round4 score left-bordered placeholder">score389</td>
    <td class="round2 left-bordered"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  



  <!-- Round 1 - Match 10 (L3 vs L4) -->
  <tr>
    <td class="round16 player">Farley W</td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2 left-bordered"></td>
    <td class="round1"></td>
    <td class="roundQ"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player left-bordered">Farley W</td>
    <td class="round4"></td>
    <td class="round2 left-bordered player placeholder">Player 685</td>
    <td class="round1 player"></td>
    <td class="roundQ"></td>
  </tr>
  <tr>
    <td class="round16 player">Hiram Z</td>
    <td class="round8 score left-bordered">6-7 (4-7), 7-5, (10-4)</td>
    <td class="round4 left-bordered"></td>
    <td class="round2 left-bordered score placeholder">Score 685</td>
    <td class="round1 "></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  
  <!-- Round 2 - Match 18 (L15 vs winner of match 10) -->
  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4 player left-bordered ">Farley W</td>
    <td class="round2 left-bordered "></td>
    <td class="round1 "></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player ">Rahul P</td>
    <td class="round4 score left-bordered ">7-6 (7-5), retired</td>
    <td class="round2 "></td>
    <td class="round1 "></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  
  <!-- Round 3 - Match 23 (winner of 17 vs winner of 18) -->
  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>




  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2 "></td>
    <td class="round1 "></td>
    <td class="roundQ left-bordered"></td>
  </tr>



  <tr>
    <td class="round16 player">Jason B</td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player left-bordered">Greg B</td>
    <td class="round4"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16 player">Greg B</td>
    <td class="round8 score left-bordered">7-5, 6-4</td>
    <td class="round4 left-bordered"></td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="round4 left-bordered player placeholder">Tournament Winner</td>
  </tr>
  
  <!-- Round 2 - Match 17 (L16 vs winner of match 9) -->
  <tr>
    <td class="round16"></td>
    <td class="round8 "></td>
    <td class="round4 player left-bordered">Greg B</td>
    <td class="round2"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player ">Arthur R</td>
    <td class="round4 score left-bordered ">6-2, 6-4</td>
    <td class="round2 left-bordered"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  



  <!-- Round 1 - Match 10 (L3 vs L4) -->
  <tr>
    <td class="round16 player">Jake H</td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2 left-bordered"></td>
    <td class="round1"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player left-bordered">Dan P</td>
    <td class="round4  "></td>
    <td class="round2 left-bordered player ">Greg B</td>
    <td class="round1 player"></td>
    <td class="roundQ left-bordered"></td>
  </tr>
  <tr>
    <td class="round16 player">Dan P</td>
    <td class="round8 score left-bordered">6-4, 6-1</td>
    <td class="round4 left-bordered"></td>
    <td class="round2 left-bordered score ">6-3, 7-5</td>
    <td class="round1 "></td>
    <td class="roundQ "></td>
  </tr>
  
  <!-- Round 2 - Match 18 (L15 vs winner of match 10) -->
  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4 player left-bordered ">Dan P</td>
    <td class="round2 left-bordered score"></td>
    <td class="round1 "></td>
    <td class="roundQ "></td>
  </tr>
  <tr>
    <td class="round16"></td>
    <td class="round8 player ">Evan D</td>
    <td class="round4 score left-bordered ">6-4, 6-7 (6-8), 10-6</td>
    <td class="round2 "></td>
    <td class="round1 "></td>
    <td class="roundQ"></td>
  </tr>
  
  <!-- Round 3 - Match 23 (winner of 17 vs winner of 18) -->
  <tr>
    <td class="round16"></td>
    <td class="round8"></td>
    <td class="round4"></td>
    <td class="round2 "></td>
    <td class="round1 "></td>
    <td class="roundQ "></td>
  </tr>

  




</table>

</div>




</div>


























